import {ILauncherServiceFactory} from '../launcher-service-factory.interface';
import {IRegulationPresetValues} from './regulation-preset-values.interface';
import {IPreset} from '../presets/preset.interface';

export class RegulationPreset implements IPreset {
    constructor(public readonly name: string,
                private readonly _values: IRegulationPresetValues,
                private readonly services: ILauncherServiceFactory) {

    }

    applyPreset(): void {
        this.services.configsStorage.applyRegulationPreset(this._values);
    }

}


export abstract class RegulationBase {
    protected constructor(public readonly id: number,
                          public readonly name: string,
                          protected readonly services: ILauncherServiceFactory){
    }

    abstract getPresets(): IPreset[];
}